import { render, staticRenderFns } from "./FormToimittaja.vue?vue&type=template&id=8c801a7c&scoped=true&"
import script from "./FormToimittaja.vue?vue&type=script&lang=js&"
export * from "./FormToimittaja.vue?vue&type=script&lang=js&"
import style0 from "./FormToimittaja.vue?vue&type=style&index=0&id=8c801a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c801a7c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c801a7c')) {
      api.createRecord('8c801a7c', component.options)
    } else {
      api.reload('8c801a7c', component.options)
    }
    module.hot.accept("./FormToimittaja.vue?vue&type=template&id=8c801a7c&scoped=true&", function () {
      api.rerender('8c801a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormToimittaja.vue"
export default component.exports